import moment from 'moment';
import { required, between, maxLength } from 'vuelidate/lib/validators';
import date from '../../../common/js/validators/date';
import ageGreaterThan from '../../../common/js/validators/age-greater-than';
import ageLessThan from '../../../common/js/validators/age-less-than';
import { BACKEND_DATE_FORMAT } from '../../../common/js/constants/constants';
import VueCurrencyInput from '@ui-common/vue-currency-input';
import datePicker from '../../../common/components/date-picker/date-picker';
import VueErrorMessage from '@ui-common/vue-error-message';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueCaptcha from '@ui-common/vue-captcha';
const MIN_CARD_CREDIT_LINE = 50000;
const MIN_LOAN_AMOUNT = 50000;
const LOAN_AMOUNT_MAXLENGTH = 15;
const BIRTH_DATE_MAXIMUM = 120;
const BIRTH_DATE_MINIMUM = 18;
export default {
	data() {
		return {
			model: {
				birthDate: null,
				hasAccount: '',
				income: null,
				hasLoan: null,
				inKhr: null,
				cardCreditLine: null,
				monthlyFee: null,
				loanAmount: null,
				payingLoan: null,
				captchaText: null
			},
			captchaErrorNeedsOnBlur: true,
			captchaServerError: null
		};
	},
	props: {
		minimumIncome: {
			required
		},
		captcha: {},
		captchaError: {},
		preCalculated: {
			required
		}
	},
	components: {
		VueCurrencyInput,
		datePicker,
		VueErrorMessage,
		VueSelect,
		VueSelectOption,
		VueRadioGroup,
		VueCaptcha
	},
	validations() {
		let model = {
			birthDate: {
				required,
				validDate: date(BACKEND_DATE_FORMAT),
				over18years: ageGreaterThan(BACKEND_DATE_FORMAT, BIRTH_DATE_MINIMUM),
				ageLessThan70: ageLessThan(BACKEND_DATE_FORMAT, BIRTH_DATE_MAXIMUM)
			},
			hasAccount: {
				required
			},
			income: {
				required,
				minimum: between(this.minimumIncome, Infinity),
				maxLength: maxLength(LOAN_AMOUNT_MAXLENGTH)
			},
			hasLoan: {
				required
			},
			monthlyFee: {
				onlyOneRequired: function () {
					return this.onlyOneRequired();
				},
				maxLength: maxLength(LOAN_AMOUNT_MAXLENGTH)
			},
			cardCreditLine: {
				onlyOneRequired: function () {
					return this.onlyOneRequired();
				},
				minimum: between(MIN_CARD_CREDIT_LINE, Infinity),
				maxLength: maxLength(LOAN_AMOUNT_MAXLENGTH)
			},
			loanAmount: {
				onlyOneRequired: function () {
					return this.onlyOneRequired();
				},
				minimum: between(MIN_LOAN_AMOUNT, Infinity),
				maxLength: maxLength(LOAN_AMOUNT_MAXLENGTH)
			},
			payingLoan: {
				requiredConditional: function () {
					return (this.model.payingLoan && this.model.hasLoan == 'hasLoan') || this.model.hasLoan == 'notHasLoan';
				}
			},
			inKhr: {
				required
			},
			captchaText: {}
		};

		if (this.captcha && this.captcha.htmlFragment) {
			model.captchaText = { required };
		}
		return { model };
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		todayMinus18YearsAnd1Day() {
			return moment(new Date()).subtract(BIRTH_DATE_MINIMUM, 'years').subtract(1, 'day').format(BACKEND_DATE_FORMAT);
		},
		todayMinus100Years() {
			return moment(new Date()).subtract(BIRTH_DATE_MAXIMUM, 'years').add(1, 'days').format(BACKEND_DATE_FORMAT);
		},
		todayMinus70Years() {
			return moment(new Date()).subtract(BIRTH_DATE_MAXIMUM, 'years').format(BACKEND_DATE_FORMAT);
		},
		todayMinus100YearsMonth() {
			return moment(new Date()).subtract(BIRTH_DATE_MAXIMUM, 'years').startOf('month').format(BACKEND_DATE_FORMAT);
		},
		birthDateMaximum() {
			return BIRTH_DATE_MAXIMUM;
		},
		birthDateMinimum() {
			return BIRTH_DATE_MINIMUM;
		}
	},
	watch: {
		captcha(newVal) {
			if (newVal) {
				this.model.captchaText = '';
				this.$v.model.captchaText.$reset();
			}
		},
		captchaError(value) {
			this.captchaServerError = value;
		}
	},
	methods: {
		resetLoanFields() {
			if (this.model.hasLoan == 'notHasLoan') {
				this.model.cardCreditLine = null;
				this.model.monthlyFee = null;
				this.model.loanAmount = null;
				this.model.payingLoan = null;
				this.$v.model.cardCreditLine.$reset();
				this.$v.model.monthlyFee.$reset();
				this.$v.model.loanAmount.$reset();
				this.$v.model.payingLoan.$reset();
			}
		},
		onlyOneRequired() {
			return (
				((this.model.cardCreditLine || this.model.monthlyFee || this.model.loanAmount) && this.model.hasLoan == 'hasLoan') ||
				this.model.hasLoan == 'notHasLoan'
			);
		},
		sendForm() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.captchaErrorNeedsOnBlur = false;
				this.$emit('on-form-sent', this.model);
			} else {
				this.$nextTick(() => {
					let elem = document.querySelector(`input[aria-invalid=true],select[aria-invalid=true],
					button[aria-invalid=true], fieldset[aria-invalid=true] input:first-of-type`);
					elem.focus();
				});
			}
		},
		onBlurCaptcha() {
			if (this.captchaErrorNeedsOnBlur) {
				this.$v.model.captchaText.$touch();
			}
			this.captchaErrorNeedsOnBlur = true;
		},
		onCaptchaInput() {
			this.captchaServerError = false;
		},
		onCaptchaFocus() {
			this.captchaErrorNeedsOnBlur = true;
		},
		sendGTM(visible) {
			this.$gtm.trackEvent({
				event: visible ? 'khrListViewOpen' : 'khrListViewClose'
			});
		}
	},
	created() {
		this.captchaServerError = this.captchaError;
	}
};
